// extracted by mini-css-extract-plugin
export var deliveryRow = "_qt-a";
export var fixedHeight = "_qt-4";
export var freightLogo = "_qt-9";
export var fullWidth = "_qt-3";
export var priceColumn = "_qt-5";
export var radioSelected = "_qt-7";
export var radioUnselected = "_qt-6";
export var selectedOption = "_qt-2";
export var selectedOptionContainer = "_qt-1";
export var selection = "_qt-0";
export var tallSkeletonText = "_qt-8";